import microuniversoApi from 'app/api/microuniversoApi'
import globalMU from 'globalMU'
import React, { useEffect, useState } from 'react'
import { Breadcrumb2Container } from '../breadcrumb2/Breadcrumb2Container'
import { Separador } from '../separador/Separador'
import {
    ControleColunasMetaBonus,
    FiltroConsultarMetaBonus,
    ItemResultadoMetaBonus,
    PeriodoMetaBonus,
} from '../../types/MetaBonus'
import { ConsultarMetaBonusResultado } from './ConsultarMetaBonusResultado'

declare var window: any

const estilosPesquisarCliente = require('app/components/pesquisa-cliente/pesquisar-cliente.module.scss').default

type Filial = { Oid: number; Descricao: string }

export const ConsultarMetaBonusContainer = () => {

    const [filiais, setFiliais] = useState<Filial[]>([])
    const [oidFilialPadrao, setOidFilialPadrao] = useState<number>(0)
    const [codigoFilialPadrao, setCodigoFilialPadrao] = useState('')
    const [codVendPadrao, setCodVendPadrao] = useState('')
    const [ehGerente, setEhGerente] = useState(false)
    const [carregando, setCarregando] = useState(true)
    const [periodos, setPeriodos] = useState<PeriodoMetaBonus[]>([])
    const [filtro, setFiltro] = useState<FiltroConsultarMetaBonus>({
        oidFilial: 0, codVend: '', oidPeriodo: 0,
        considerarCancelados: true, apenasComVendas: false
    })
    const [itens, setItens] = useState<ItemResultadoMetaBonus[] | null>(null)
    const [controle, setControle] = useState<ControleColunasMetaBonus>({
        ExibirVendasSemDesconto: true, ExibirValorPremioMetaDesconto: true
    })
    const [consultou, setConsultou] = useState(false)
    const [pesquisando, setPesquisando] = useState(false)

    useEffect(() => {
        const inicializar = async () => {
            try {
                globalMU.blockUI({ tryPassiveLoading: true })

                const [vendedor, listaFiliais, listaPeriodos] = await Promise.all([
                    microuniversoApi.Vendedor.ObterVendedorAutenticado(),
                    microuniversoApi.Vendedor.listarFiliaisOrcamento(),
                    microuniversoApi.MetasBonus.ListarPeriodos(),
                ])

                const codVend = vendedor?.Codigo ?? ''
                const oidFilial = vendedor?.OidFilial ?? 0
                const codigoFilial = vendedor?.CodigoFilial ?? ''

                const filialOrdenada = (listaFiliais ?? []).sort((a, b) => a.Descricao.localeCompare(b.Descricao))
                setCodVendPadrao(codVend)
                setOidFilialPadrao(oidFilial)
                setCodigoFilialPadrao(codigoFilial)
                setFiliais(filialOrdenada)
                setPeriodos(listaPeriodos ?? [])

                let gerente = false
                if (codVend) {
                    try {
                        const resultado = await microuniversoApi.Vendedor.vendedorGerente(codVend)
                        gerente = resultado?.Gerente === true
                    } catch { }
                }
                setEhGerente(gerente)

                const oidFilialDefault = gerente
                    ? (filialOrdenada.length > 0 ? filialOrdenada[0].Oid : oidFilial)
                    : oidFilial

                setOidFilialPadrao(oidFilialDefault)

                setFiltro(prev => ({
                    ...prev,
                    oidFilial: oidFilialDefault,
                    codVend: gerente ? '' : codVend,
                    oidPeriodo: listaPeriodos?.length > 0 ? listaPeriodos[0].CampoChave : 0
                }))

            } catch {
                globalMU.showErrorMessage('Erro ao carregar dados iniciais.')
            } finally {
                globalMU.unblockUI()
                setCarregando(false)
            }
        }
        inicializar()
    }, [])

    const limpar = () => {
        setFiltro({
            oidFilial: oidFilialPadrao,
            codVend: ehGerente ? '' : codVendPadrao,
            oidPeriodo: periodos.length > 0 ? periodos[0].CampoChave : 0,
            considerarCancelados: true, apenasComVendas: false
        })
        setItens(null)
        setConsultou(false)
    }

    const pesquisar = async () => {
        if (!filtro.oidPeriodo) { globalMU.showWarnMessage('Período deve ser selecionado.'); return }
        try {
            setPesquisando(true)
            globalMU.blockUI()
            const resposta = await microuniversoApi.MetasBonus.Consultar(filtro)
            if (!resposta) return
            setItens(resposta.Itens ?? [])
            setControle(resposta.Controle ?? { ExibirVendasSemDesconto: true, ExibirValorPremioMetaDesconto: true })
            setConsultou(true)
        } catch {
            globalMU.showErrorMessage('Erro ao consultar metas e bônus.')
        } finally {
            setPesquisando(false)
            globalMU.unblockUI()
        }
    }

    if (carregando) return null

    return (
        <>
            <Breadcrumb2Container
                passos={['Metas e Bônus']}
                id="ConsultarMetaBonusContainer"
                exibirBotaoLimpar={true}
                exibirBotaoVoltar={false}
                onBotaoLimparClicado={limpar}
            />

            {!consultou && (
                <fieldset disabled={pesquisando}
                    id="ConsultarMetaBonusContainer_FildSet"
                >
                    <div>
                        <Separador />
                        <table style={{ borderCollapse: 'collapse', marginTop: '8px' }}
                             id="ConsultarMetaBonusContainer_table"
                        >
                            <tbody
                                 id="ConsultarMetaBonusContainer_tbody"
                            >
                                <tr>
                                    <td style={{ textAlign: 'right', paddingRight: '6px', paddingBottom: '6px', whiteSpace: 'nowrap' }}>Filial</td>
                                    <td style={{ paddingBottom: '6px' }}>
                                        <select
                                            style={{ minWidth: '340px', padding: '2px', border: '1px solid var(--mu-borda, #c5cacb)', boxSizing: 'border-box' }}
                                            value={(filtro.oidFilial) ?? ""}
                                            disabled={!ehGerente || pesquisando}
                                            onChange={e => setFiltro(prev => ({ ...prev, oidFilial: Number(e.target.value) }))}
                                        >
                                            {filiais.map(f => (
                                                <option key={f.Oid} value={String(f.Oid)}>{f.Descricao}</option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', paddingRight: '6px', paddingBottom: '6px', whiteSpace: 'nowrap' }}>Vendedor</td>
                                    <td style={{ paddingBottom: '6px' }}>
                                        <input
                                            type="text"
                                            style={{ width: '340px', padding: '2px', border: '1px solid var(--mu-borda, #c5cacb)', boxSizing: 'border-box' }}
                                            value={(filtro.codVend) ?? ""}
                                            disabled={!ehGerente || pesquisando}
                                            onChange={e => setFiltro(prev => ({ ...prev, codVend: e.target.value }))}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', paddingRight: '6px', paddingBottom: '6px', whiteSpace: 'nowrap' }}>Período</td>
                                    <td style={{ paddingBottom: '6px' }}>
                                        <select
                                            style={{ minWidth: '340px', padding: '2px', border: '1px solid var(--mu-borda, #c5cacb)', boxSizing: 'border-box' }}
                                            value={(filtro.oidPeriodo) ?? ""}
                                            disabled={pesquisando}
                                            onChange={e => setFiltro(prev => ({ ...prev, oidPeriodo: Number(e.target.value) }))}
                                        >
                                            disabled={pesquisando || periodos.length === 0}
                                            {periodos.length === 0
                                                ? <option value={0} disabled>Nenhum período cadastrado</option>
                                                : periodos.map(p => (
                                                    <option key={p.CampoChave} value={p.CampoChave}>{p.CampoPesquisa}</option>
                                                ))
                                            }
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', paddingRight: '6px', paddingBottom: '6px', whiteSpace: 'nowrap' }}
                                    >
                                       Considerar Itens Cancelados
                                    </td>
                                    <td style={{ paddingBottom: '6px' }}>
                                        <input
                                            type="checkbox"
                                            id="ConsultarMetaBonusContainer_CheckBox1"
                                            checked={filtro.considerarCancelados}
                                            disabled={pesquisando}
                                            onChange={e => setFiltro(prev => ({ ...prev, considerarCancelados: e.target.checked }))}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', paddingRight: '6px', paddingBottom: '6px', whiteSpace: 'nowrap' }}
                                    >
                                        Listar Apenas Vendedores com Vendas no Período
                                    </td>
                                    <td style={{ paddingBottom: '6px' }}>
                                        <input
                                            type="checkbox"
                                            id="ConsultarMetaBonusContainer_CheckBox2"
                                            checked={filtro.apenasComVendas}
                                            disabled={pesquisando}
                                            onChange={e => setFiltro(prev => ({ ...prev, apenasComVendas: e.target.checked }))}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div>
                        <button
                            type="button"
                            className="_flex _my-2 no-global-button"
                             id="ConsultarMetaBonusContainer_BotaoPesquisar"
                            style={{
                                padding: '7px 13px',
                                background: 'var(--mu-primaria, #409fff)',
                                color: '#fff',
                                border: '1px solid rgba(0,0,0,0.3)',
                                borderRadius: '2px',
                                boxShadow: '0 -16px 2px 0 rgb(0 0 0 / 12%) inset',
                                textShadow: '0 1px 1px rgb(0 0 0 / 30%)',
                                font: '13px arial, sans-serif',
                                opacity: pesquisando ? 0.6 : 1,
                                cursor: pesquisando ? 'not-allowed' : 'pointer'
                            }}
                            onClick={pesquisar}
                            disabled={pesquisando}
                        >
                            {pesquisando ? 'Pesquisando...' : 'Pesquisar'}
                        </button>
                    </div>
                </fieldset>
            )}

            {consultou && itens !== null && (
                <>
                    <Separador />
                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '8px' }}>
                        <button
                            type="button"
                            className={estilosPesquisarCliente.botao}
                            style={{ background: 'var(--mu-superficie-escura, #6c757d)' }}
                            onClick={() => setConsultou(false)}
                        >
                            Voltar ao Filtro
                        </button>
                    </div>
                    <ConsultarMetaBonusResultado itens={itens} controle={controle} />
                </>
            )}
        </>
    )
}

window.ConsultarMetaBonusContainer = ConsultarMetaBonusContainer
